export default {
	'add-new-set': '',
	set: '',
	'the-set': ''
}